/**
 * O link do e-mail da confirmação (docs/spec/email.md): `?confirm-email=<código>`. A página lê o código
 * uma vez e o tira do endereço, para ele não ficar no histórico nem num favorito.
 */
import { EMAIL_CONFIRMATION_PARAM } from '../shared.js';

/** O código do link em `search` (null sem ele) e o resto da busca, sem o código. */
export function emailLinkOf(search: string): { code: string | null; rest: string } {
  const params = new URLSearchParams(search);
  const code = params.get(EMAIL_CONFIRMATION_PARAM)?.trim() || null;
  params.delete(EMAIL_CONFIRMATION_PARAM);
  const rest = params.toString();
  return { code, rest: rest ? `?${rest}` : '' };
}

/** Tira o código do endereço da página e o devolve; null quando a página não veio do link. */
export function takeEmailLink(): string | null {
  if (!new URLSearchParams(window.location.search).has(EMAIL_CONFIRMATION_PARAM)) return null;
  const { code, rest } = emailLinkOf(window.location.search);
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${rest}${window.location.hash}`);
  return code;
}
